/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Pricing<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Pricing
   * @name GetPricingList
   * @request GET:/Pricing/GetPricing
   */
  getPricingList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Pricing/GetPricing`,
      method: "GET",
      ...params,
    });
}
